import { useState } from 'react';
import axios from 'axios';
import Modal from './Modal';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Form from '../Form/Form';
import InputText from '../Form/Fields/InputText';
import InputDate from '../Form/Fields/InputDate';
import Select from '../Form/Fields/Select';
import Button from '../Form/Button';
import { API_BASE_URL } from '../../api';

import './CreateProductModal.scss';

const TYPE_OPTIONS = [
    { value: 'TOUS_PRODUITS', label: 'Tous les produits vendus', description: 'Liste complète de tous les produits vendus sur la période, sans limite' },
    { value: 'COMPLET', label: "Rapport d'activité complet", description: "Vue d'ensemble : ventes, produits, paiements et inventaire" },
    { value: 'VENTES', label: 'Ventes', description: "Évolution du chiffre d'affaires et indicateurs clés sur la période" },
    { value: 'PRODUITS', label: 'Produits les plus vendus', description: 'Top 8 des produits les plus vendus (quantité et chiffre d\'affaires)' },
    { value: 'PAIEMENTS', label: 'Moyens de paiement', description: 'Répartition des ventes par mode de paiement' },
    { value: 'INVENTAIRE', label: "Inventaire (écarts)", description: 'Écarts constatés lors des inventaires validés sur la période' },
];

const toISODate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const defaultTo = new Date();
const defaultFrom = new Date();
defaultFrom.setDate(defaultFrom.getDate() - 29);

export default function GenerateReportModal({ show, onClose, onGenerated }) {
    const [submitting, setSubmitting] = useState(false);

    const defaultValues = {
        type: 'COMPLET',
        name: '',
        from: toISODate(defaultFrom),
        to: toISODate(defaultTo),
    };

    // InputDate hands back a raw Date object once the user touches the field
    // (only the untouched default stays a plain "yyyy-MM-dd" string) — normalize
    // to a local-time date-only string so the backend's LocalDate parses correctly
    // and we don't shift a day via UTC conversion.
    const normalizeDate = (v) => (v instanceof Date ? toISODate(v) : v);

    const onSubmit = async (data) => {
        setSubmitting(true);
        try {
            const payload = {
                type: data.type,
                name: data.name?.trim() || null,
                from: normalizeDate(data.from),
                to: normalizeDate(data.to),
            };
            const { data: report } = await axios.post(`${API_BASE_URL}/api/v1/reports`, payload, { withCredentials: true });

            toast.success('Rapport généré.');
            onGenerated?.(report);
            onClose();
        } catch (e) {
            console.error(e);
            toast.error('Échec de la génération du rapport.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            id="generateReportModal"
            title="Générer un rapport"
            show={show}
            onClose={onClose}
            icon={faFilePdf}
            iconBg="#fef2f2"
            iconColor="#dc2626"
            footer={
                <Button
                    isLoading={submitting}
                    loadingMessage="Génération…"
                    className="btn btn-primary w-100"
                    type="submit"
                    form="generateReportForm"
                >
                    Générer le PDF
                </Button>
            }
        >
            <Form id="generateReportForm" onSubmit={onSubmit} defaultValues={defaultValues}>

                <div className="cdm-section">
                    <p className="cdm-section__label">Paramètres</p>

                    <div className="mb-2">
                        <span className="cdm-field-label">Type de rapport</span>
                        <Select name="type" options={TYPE_OPTIONS} />
                    </div>

                    <div>
                        <span className="cdm-field-label">Nom du rapport</span>
                        <InputText name="name" placeholder="Optionnel" />
                    </div>
                </div>

                <div className="cdm-section" style={{ marginBottom: 0 }}>
                    <p className="cdm-section__label">Période</p>
                    <div className="cdm-grid-2">
                        <div>
                            <span className="cdm-field-label">Du</span>
                            <InputDate name="from" openToDate={new Date()} />
                        </div>
                        <div>
                            <span className="cdm-field-label">Au</span>
                            <InputDate name="to" openToDate={new Date()} />
                        </div>
                    </div>
                </div>

            </Form>
        </Modal>
    );
}
